import request from "./request"

export function getCreatorShop(params) {
  return request({ url: "/monetization/creator_shop_get", method: "get", params })
}

export function getPaidContent(params) {
  return request({ url: "/monetization/paid_content_detail_get", method: "get", params })
}

export function getWallet() {
  return request({ url: "/monetization/wallet_get", method: "get" })
}

export function getLiveGiftCatalog(params) {
  return request({ url: "/monetization/live_gift_catalog_get", method: "get", params })
}

export function addTip(data) {
  return request({ url: "/monetization/tip_add", method: "post", data })
}

export function addGift(data) {
  return request({ url: "/monetization/gift_add", method: "post", data })
}

export function addPurchase(data) {
  return request({ url: "/monetization/purchase_add", method: "post", data })
}

export function getPurchases(params) {
  return request({ url: "/monetization/purchase_list_get", method: "get", params })
}

export function getCoinTransactions(params) {
  return request({ url: "/monetization/transaction_list_get", method: "get", params })
}
